export const isPassiveMetaBusinessAgentTranscript = message => {
  const attributes =
    message?.content_attributes || message?.contentAttributes || {};
  const importedFromHistory =
    attributes.imported_from_history ?? attributes.importedFromHistory;
  const metaBusinessAgentStandby =
    attributes.meta_business_agent_standby ??
    attributes.metaBusinessAgentStandby;
  const metaBusinessAgentProjection =
    attributes.meta_business_agent_projection ??
    attributes.metaBusinessAgentProjection;
  const metaBusinessAgentMessage =
    attributes.meta_business_agent_message ??
    attributes.metaBusinessAgentMessage;

  return (
    importedFromHistory === true &&
    (metaBusinessAgentStandby === true ||
      metaBusinessAgentProjection === true ||
      metaBusinessAgentMessage === true)
  );
};
